import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Spin, Card, Image, Row, Col, Typography, Divider } from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import {
  GET_ASSETS
} from '../../state/assets/types';
import { RESOURCE } from '../../config/constants/alerts';
import PropTypes from 'prop-types';

const spinnerIcon = <LoadingOutlined style={{ fontSize: 20 }} spin />;
const { Title } = Typography;

/**
 * Component that returns a component that show assets.
 * @component
 * @returns {Element} view with assets preview
 */
const ShowAssets = ({ getAssets, assets }) => {

  const { params } = useParams();
  const [loaderSpinning, setLoaderSpinning] = useState(true);
  const [lessorList, setLessorList] = useState([]);
  const [lesseeList, setLesseeList] = useState([]);
  const [codebtorList, setCodebtorList] = useState([]);

  useEffect(() => { getAssets(params); }, [params]);
  useEffect(() => {
    if (assets.arrendador || assets.arrendatario || assets.codeudor) {
      const lessor = assets.arrendador.map(asset => (
        Object.values(asset).map(value => (replaceHead(value)))
      ));
      const lessee = assets.arrendatario.map(asset => (
        Object.values(asset).map(value => (replaceHead(value)))
      ));
      if (assets.codeudor[0]) {
        const codebtor = assets.codeudor.map(asset => (
          Object.values(asset).map(value => (replaceHead(value)))
        ));
        setCodebtorList(codebtor);
      }
      setLessorList(lessor);
      setLesseeList(lessee);
      setLoaderSpinning(false);
    }
  }, [assets]);

  const replaceHead = (image) => {
    if (image.includes('image/png;')) {
      return (image.replace('image/png;', 'data:image/png;base64,'));
    } else {
      return (image.replace('image/jpg;', 'data:image/jpg;base64,'));
    }
  };

  return (
    <Spin
      spinning={loaderSpinning}
      indicator={spinnerIcon}
      tip="Cargando..."
    >
      <Card>
        <Row className="justify-content-center">
          <Col span={24}>
            <Title level={3}>Evidencias de participantes</Title>
          </Col>
        </Row>
        <Row gutter={16} >
          <Col span={24}>
            <p><b>EVIDENCIAS DE ARRENDADOR</b></p>
          </Col>
          {lessorList && lessorList.map(asset => (
            asset.map((image, key) => (
              <Col lg={12} key={key}>
                <Image src={image} />
              </Col>
            ))
          ))}
          <Divider />
        </Row>
        <Row gutter={16} >
          {lesseeList && lesseeList.map((asset, i) => (
            <React.Fragment key={i}>
              <Col span={24}>
                <p><b>EVIDENCIAS DE ARRENDATARIO {lesseeList.length > 1 && `${i + 1}`}</b></p>
              </Col>
              {asset.map((image, key) => (
                <Col lg={12} key={key}>
                  <Image src={image} />
                </Col>
              ))}
              <Divider />
            </React.Fragment>
          ))}
        </Row>
        {assets.codeudor && assets.codeudor[0] &&
          <Row gutter={16} >
            {codebtorList && codebtorList.map((asset, i) => (
              <React.Fragment key={i}>
                <Col span={24}>
                  <p><b>EVIDENCIAS DE CODEUDOR {codebtorList.length > 1 && `${i + 1}`}</b></p>
                </Col>
                {asset.map((image, key) => (
                  <Col lg={12} key={key}>
                    <Image src={image} />
                  </Col>
                ))}
                <Divider />
              </React.Fragment>
            ))}
          </Row>
        }
      </Card>
    </Spin>
  );
};

ShowAssets.propTypes = {
  getAssets: PropTypes.func.isRequired,
  assets: PropTypes.object.isRequired,
};

const data = (state) => ({
  assets: state.assets.assets,
});

const action = (dispatch) => ({
  getAssets: (id) => dispatch({ type: GET_ASSETS, payload: { id, resource: RESOURCE.GET_ASSETS } }),
});

export default connect(data, action)(ShowAssets);